import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-labels--labels

const TagStyle = styled.span`
    padding: 0.4em 0.6em;
    margin: 1em 0.2em;
    display: inline-block;

    i {
        color: ${props => props.color};
    }
`;

const CaptionStyle = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #06152B;
`;

const getIconProps = (iconName) => {
  let color = '#0095FA';
  let icon = '';
  switch (iconName) {
    case 'location':
      color = '#0095FA';
      icon = 'map marker alternate';
      break;
    case 'ticket':
      color = '#49BACA';
      icon = 'ticket';
      break;
    case 'challenge':
      color = '#6254CA';
      icon = 'code';
      break;
    case 'date':
      icon = 'calendar minus';
      break;
    case 'team':
      icon = 'users';
      break;
    default:
      color = '#0095FA';
      icon = 'map marker alternate';
      break;
  }
  return { color, icon };
};


export const Tag = ({ iconName, label }) => {
  const { color, icon } = getIconProps(iconName);

  return (
    <TagStyle color={color}>
      <Icon name={icon} />
      <CaptionStyle>{label}</CaptionStyle>
    </TagStyle>
  );
};


Tag.defaultProps = {
  iconName: 'location',
  label: 'Location',
  card: false
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/tag.js